(function(){
  'use strict';

  function cleanupLabMarker(){
    var badge=document.getElementById('fnx-lab-build');
    if(badge) badge.remove();
    document.title=document.title.replace(/^\[H02\]\s*/,'');
  }

  function scheduleCleanup(){
    setTimeout(cleanupLabMarker,0);
    setTimeout(cleanupLabMarker,40);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',scheduleCleanup,{once:true});
  }else{
    scheduleCleanup();
  }

  window.addEventListener('load',scheduleCleanup,{once:true});

  if('MutationObserver' in window){
    new MutationObserver(function(){
      var badge=document.getElementById('fnx-lab-build');
      if(badge) badge.remove();
    }).observe(document.documentElement,{childList:true,subtree:true});
  }
})();
